<template>
  <b-col cols="12" xl="3">
    <template v-if="cardData">
      <b-card style="min-height: 40rem">
        <strong style="font-size: 17px" class="text-primary  p-25">
          {{ cardData.heading }}
        </strong>
        <v-select
            v-if="cardData.order===10"
            class=""
            v-model="selectedProductId"
            label="title"
            :options="coursesList"
            :reduce="title => title.id"
        />
        <template v-if="cardData.data &&cardData.data.length && typeof cardData.data.length === 'number'">
          <div v-for="(item,idx) in cardData.data" class="d-flex align-items-center my-1 justify-content-between">

            <span dir="auto" class="text-secondary " style="font-size: 16px;overflow-wrap: anywhere">{{
                item.title
              }}</span>
            <span dir="auto" style="font-size: 16px;overflow-wrap: anywhere">{{
                cardData.hasPrice ? Intl.NumberFormat('en-US').format(item.count) : item.count || item.duration
              }}
                          <small v-if="cardData.hasPrice">تومان</small>
            </span>

          </div>
        </template>
        <template v-else-if="cardData.data===undefined">
          <div  class="d-flex align-items-center my-1 justify-content-between">
            <span class="text-secondary">
              داده ای موجود نیست
            </span>
          </div>
        </template>
        <template v-else>
          <div v-for="(item,idx) in Object.keys(cardData.data)"
               class="d-flex align-items-center my-1 justify-content-between">
            <template v-if="Object.keys(cardData.data).length>0">
              <span dir="auto" v-if="!item.includes('createDate')" class="text-secondary text-justify "
                    style="font-size: 16px;">{{ getObjectKey(item) }}</span>
              <span dir="auto" v-if="!item.includes('createDate')" style="font-size: 16px">{{
                  cardData.hasPrice ? Intl.NumberFormat('en-US').format(cardData.data[item]) : cardData.data[item]
                }}
              <small v-if="cardData.hasPrice">تومان</small>
          </span>
            </template>

          </div>
        </template>
      </b-card>
    </template>

  </b-col>
</template>

<script>
import {BCol, BCard, BBadge} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {BCol, BCard, BBadge, vSelect},
  props: {
    cardData: {
      type: Object,
      required: true
    },
    coursesList: {
      type: Array,
      required: false
    }
  },
  watch: {
    selectedProductId: function (val) {
      this.$emit('getNewProductId', val)
    }
  },
  name: "smartReportCard",
  data() {
    return {
      selectedProductId: '',
      tableKeys: {
        yesterday: 'دیروز',
        dayBeforeYesterday: 'پریروز',
        threeDayAgo: '3 روز پیش',
        fourDayAgo: '4 روز پیش',
        fiveDayAgo: '5 روز پیش',
        sixDayAgo: '6 روز پیش',
        sevenDayAgo: '7 روز پیش',
        threeDayBefore: '3 روز پیش',
        fourDayBefore: '4 روز پیش',
        fiveDayBefore: '5 روز پیش',
        sixDayBefore: '6 روز پیش',
        sevenDayBefore: '7 روز پیش',
        currentMonth: 'ماه جاری',
        prevousMonth: 'ماه گذشته',
        currentYear: 'سال جاری',
        lastYear: 'سال گذشته',
        lastMonth: 'ماه گذشته'

      }
    }
  },
  methods: {
    getObjectKey(item) {
      return this.tableKeys[item]
    },
  }
}
</script>

<style scoped>

</style>
